import React from 'react';

import Container from '@mui/material/Container';

import classes from './NgzChallengeLanding.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { ChallengesHeader } from '../../components/ChallengesHeader/ChallengesHeader';
import { ChallengeLandingContent } from '../../containers/ChallengeLandingContent/ChallengeLandingContent';
import { publicChallengeInfoService } from '../../services/challenge-info/publicChallengeInfoService';
import { getRouteParam } from '../../../shared/utils/angularUtils';
import { useChallengeInfo } from '../../hooks/useChallengeInfo';
import { LandingHeader } from './LandingHeader/LandingHeader';
import { ErrorState } from '../../../shared/components/ErrorState/ErrorState';

const NgzChallengeLanding = () => {
  const challengeId = getRouteParam('challengeId');

  const { challengeInfo, isNotFound } = useChallengeInfo({
    challengeId,
    getChallengeInfo: publicChallengeInfoService.getChallengeInfo,
  });

  if (isNotFound) {
    return (
      <ErrorState
        title="🚧 This challenge isn't live yet"
        description={
          <>
            This challenge hasn&apos;t launched yet — the page is still in draft mode.
            <br />
            Stay tuned — we&apos;re getting everything ready for you.
          </>
        }
      />
    );
  }

  if (!challengeInfo) {
    return null;
  }

  return (
    <>
      <ChallengesHeader />
      <Container maxWidth="md">
        <ChallengeLandingContent
          challengeInfo={challengeInfo}
          headerBlock={
            <div className={classes.headerContainer}>
              <LandingHeader
                challengeStatus={challengeInfo.challenge.status}
                importantDates={challengeInfo.challenge.importantDates}
              />
            </div>
          }
        />
      </Container>
    </>
  );
};

angularizeWithProviders(NgzChallengeLanding, 'ngzChallengeLanding', {});
